"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSupplier = addSupplier;
exports.batchDeleteSupplier = batchDeleteSupplier;
exports.checkSupplierName = checkSupplierName;
exports.deleteMerchant = exports.createMerchant = void 0;
exports.deleteSupplier = deleteSupplier;
exports.exportSupplierData = exportSupplierData;
exports.getAllCompany = getAllCompany;
exports.getAllUser = getAllUser;
exports.getCooperationStatusOptions = getCooperationStatusOptions;
exports.getMerchantList = exports.getMerchantDetail = void 0;
exports.getMockMerchantList = getMockMerchantList;
exports.getMockStoreList = getMockStoreList;
exports.getRenshouDictData = getRenshouDictData;
exports.getStoreTypeOptions = getStoreTypeOptions;
exports.getSupplierDetail = getSupplierDetail;
exports.getSupplierList = getSupplierList;
exports.getSupplierOptions = getSupplierOptions;
exports.getSupplierStatistics = getSupplierStatistics;
exports.syncBusinessBase = syncBusinessBase;
exports.syncBusinessBasePage = syncBusinessBasePage;
exports.syncStoreBase = syncStoreBase;
exports.syncStoreBasePage = syncStoreBasePage;
exports.triggerFullSync = triggerFullSync;
exports.updateMerchant = void 0;
exports.updateSupplier = updateSupplier;
exports.updateSupplierStatus = updateSupplierStatus;
exports.uploadImage = uploadImage;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
// 供应商管理相关接口
var API_BASE_URL = '/admin/rs/supplier';

/**
 * 获取供应商分页列表
 * @param {Object} params 查询参数
 * @param {string} params.merchantName 供应商名称
 * @param {string} params.company 归属公司
 * @param {string} params.cooperationStatus 合作状态
 * @param {string} params.maintainer 维护人
 * @param {string} params.dataSource 数据来源
 * @param {string} params.businessType 业务类型
 * @param {string} params.merchantId 商户ID
 * @param {number} params.page 页码
 * @param {number} params.limit 每页大小
 */
function getSupplierList(params) {
  // return request({
  //   url: `${API_BASE_URL}/list`,
  //   method: 'get',
  //   params: params
  // })
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/rs/supplier/list",
    method: 'get',
    params: params
  });
}

/**
 * 获取供应商详情
 * @param {number} id 供应商ID
 */
function getSupplierDetail(id) {
  // return request({
  //   url: `${API_BASE_URL}/detail/${id}`,
  //   method: 'get'
  // })
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/rs/supplier/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 新增供应商
 * @param {Object} data 供应商信息
 */
function addSupplier(data) {
  // return request({
  //   url: `${API_BASE_URL}/save`,
  //   method: 'post',
  //   data: data
  // })
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/rs/supplier/save",
    method: 'post',
    data: data
  });
}

/**
 * 编辑供应商
 * @param {Object} data 供应商信息（包含id）
 */
function updateSupplier(data) {
  // return request({
  //   url: `${API_BASE_URL}/update`,
  //   method: 'post',
  //   data: data
  // })
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/rs/supplier/update",
    method: 'post',
    data: data
  });
}

/**
 * 删除供应商
 * @param {number} id 供应商ID
 */
function deleteSupplier(id) {
  // return request({
  //   url: `${API_BASE_URL}/delete/${id}`,
  //   method: 'delete'
  // })
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/rs/supplier/delete/".concat(id),
    method: 'delete'
  });
}

/**
 * 批量删除供应商
 * @param {Array<number>} ids 供应商ID数组
 */
function batchDeleteSupplier(ids) {
  // return request({
  //   url: `${API_BASE_URL}/batchDelete`,
  //   method: 'post',
  //   data: ids
  // })
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/rs/supplier/batchDelete",
    method: 'post',
    data: ids
  });
}

/**
 * 检查供应商名称是否存在
 * @param {string} name 供应商名称
 * @param {number} excludeId 排除的ID（编辑时使用）
 */
function checkSupplierName(name, excludeId) {
  // return request({
  //   url: `${API_BASE_URL}/checkName`,
  //   method: 'get',
  //   params: { name, excludeId }
  // })
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/rs/supplier/checkName",
    method: 'get',
    params: {
      name: name,
      excludeId: excludeId
    }
  });
}

/**
 * 获取供应商统计信息
 */
function getSupplierStatistics() {
  // return request({
  //   url: `${API_BASE_URL}/statistics`,
  //   method: 'get'
  // })
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/rs/supplier/statistics",
    method: 'get'
  });
}

/**
 * 导出供应商数据Excel
 * @param {Object} params 查询参数
 * @param {string} params.merchantName 供应商名称
 * @param {string} params.company 归属公司
 * @param {string} params.cooperationStatus 合作状态
 * @param {string} params.maintainer 维护人
 * @param {string} params.dataSource 数据来源
 * @param {string} params.businessType 业务类型
 * @param {string} params.merchantId 商户ID
 */
function exportSupplierData(params) {
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/export/task',
    method: 'post',
    data: {
      type: 'merchant_supplier',
      params: params
    }
  });
}

/**
 * 更新供应商状态
 * @param {number} id 供应商ID
 * @param {string} status 状态
 */
function updateSupplierStatus(id, status) {
  return (0, _request.default)({
    url: "".concat(API_BASE_URL, "/updateStatus"),
    method: 'post',
    params: {
      id: id,
      status: status
    }
  });
}

/**
 * 获取供应商选项列表（用于下拉选择）
 */
function getSupplierOptions() {
  return (0, _request.default)({
    url: "".concat(API_BASE_URL, "/options"),
    method: 'get'
  });
}

// 店铺管理相关接口（暂时保留Mock数据，等待后端提供）
var mockStoreData = [{
  id: 1,
  storeId: 'S001',
  storeName: '阿里巴巴杭州总部店',
  merchantName: '阿里巴巴集团',
  address: '杭州市余杭区',
  storeStatus: 'open',
  businessStatus: 'operating',
  location: '浙江省杭州市余杭区文一西路969号',
  remark: '总部旗舰店',
  createTime: '2023-12-01 10:00:00',
  creator: '张三'
}, {
  id: 2,
  storeId: 'S002',
  storeName: '腾讯深圳分店',
  merchantName: '腾讯科技',
  address: '深圳市南山区',
  storeStatus: 'preparing',
  businessStatus: 'suspended',
  location: '广东省深圳市南山区科技园',
  remark: '筹备中',
  createTime: '2023-12-02 14:30:00',
  creator: '李四'
}, {
  id: 3,
  storeId: 'S003',
  storeName: '百度北京店',
  merchantName: '百度网络',
  address: '北京市海淀区',
  storeStatus: 'closed',
  businessStatus: 'closed',
  location: '北京市海淀区上地十街10号',
  remark: '已关闭',
  createTime: '2023-12-03 09:15:00',
  creator: '王五'
}];
function getMockStoreList(params) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      var filteredData = [].concat(mockStoreData);

      // 模拟筛选
      if (params.storeName) {
        filteredData = filteredData.filter(function (item) {
          return item.storeName.includes(params.storeName);
        });
      }
      if (params.merchantName) {
        filteredData = filteredData.filter(function (item) {
          return item.merchantName.includes(params.merchantName);
        });
      }
      if (params.storeStatus) {
        filteredData = filteredData.filter(function (item) {
          return item.storeStatus === params.storeStatus;
        });
      }
      resolve({
        code: 200,
        data: {
          list: filteredData,
          total: filteredData.length,
          pageNum: params.page || 1,
          pageSize: params.limit || 10
        }
      });
    }, 300);
  });
}

// 兼容性：保留旧的函数名（供应商相关）
var getMerchantList = exports.getMerchantList = getSupplierList;
var getMerchantDetail = exports.getMerchantDetail = getSupplierDetail;
var createMerchant = exports.createMerchant = addSupplier;
var updateMerchant = exports.updateMerchant = function updateMerchant(id, data) {
  return updateSupplier(_objectSpread(_objectSpread({}, data), {}, {
    id: id
  }));
};
var deleteMerchant = exports.deleteMerchant = deleteSupplier;

// 兼容性：保留Mock函数
function getMockMerchantList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise(function (resolve) {
    setTimeout(function () {
      var mockData = {
        code: 200,
        data: {
          list: [{
            id: 1,
            merchantId: 'M001',
            merchantName: '示例商户1',
            company: '爱牙库',
            cooperationStatus: '签订合同',
            businessType: '无票',
            totalAmount: 120000,
            settledAmount: 15000,
            maintainer: '张三',
            contactNumber: '微信群1',
            dataSource: '接口',
            productInfo: '100种商品',
            createTime: '2025-01-15 10:30:00',
            creator: '管理员'
          }, {
            id: 2,
            merchantId: 'M002',
            merchantName: '示例商户2',
            company: '其他公司',
            cooperationStatus: '洽谈中',
            businessType: '普票',
            totalAmount: 80000,
            settledAmount: 8000,
            maintainer: '李四',
            contactNumber: '微信群2',
            dataSource: '本地',
            productInfo: '50种商品',
            createTime: '2025-01-16 14:20:00',
            creator: '操作员'
          }],
          total: 243,
          page: params.page || 1,
          size: params.size || 10
        },
        message: '获取成功'
      };
      resolve(mockData);
    }, 300);
  });
}

/**
 * 上传图片
 * @param {FormData} formData 图片文件
 */
function uploadImage(formData) {
  return (0, _request.default)({
    url: '/admin/upload/image',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 商户门店数据同步相关接口
var SYNC_API_BASE_URL = '/admin/business-store-sync';

/**
 * 手动触发全量同步
 */
function triggerFullSync() {
  return (0, _request.default)({
    url: "".concat(SYNC_API_BASE_URL, "/full"),
    method: 'post'
  });
}

/**
 * 手动触发商户基本信息同步
 */
function syncBusinessBase() {
  return (0, _request.default)({
    url: "".concat(SYNC_API_BASE_URL, "/business-base"),
    method: 'post'
  });
}

/**
 * 手动触发门店同步
 */
function syncStoreBase() {
  return (0, _request.default)({
    url: "".concat(SYNC_API_BASE_URL, "/store"),
    method: 'post'
  });
}

/**
 * 分页同步商户基本信息
 * @param {number} current 当前页
 * @param {number} size 页大小
 */
function syncBusinessBasePage() {
  var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return (0, _request.default)({
    url: "".concat(SYNC_API_BASE_URL, "/business-base/page"),
    method: 'post',
    params: {
      current: current,
      size: size
    }
  });
}

/**
 * 分页同步门店数据
 * @param {number} current 当前页
 * @param {number} size 页大小
 */
function syncStoreBasePage() {
  var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return (0, _request.default)({
    url: "".concat(SYNC_API_BASE_URL, "/store-base/page"),
    method: 'post',
    params: {
      current: current,
      size: size
    }
  });
}

// 获取下拉选项数据相关接口

/**
 * 获取所有用户列表（维护人选项）
 * @param {string} keyword 搜索关键词
 */
function getAllUser(keyword) {
  return (0, _request.default)({
    url: '/admin/system/admin/autoList',
    method: 'get',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 获取所有公司列表（归属公司选项）
 * @param {string} keyword 搜索关键词
 */
function getAllCompany(keyword) {
  return (0, _requestMapi.default)({
    // url: '/admin/business/company/autoList',
    url: "/mapi/user/company/autoList",
    method: 'get',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 获取合作状态选项
 */
function getCooperationStatusOptions() {
  // 这里可能需要从字典接口获取，暂时返回固定选项
  return Promise.resolve([{
    label: '签订合同',
    value: '签订合同'
  }, {
    label: '合作中',
    value: '合作中'
  }, {
    label: '暂停合作',
    value: '暂停合作'
  }]);
}

/**
 * 获取仁寿字典数据
 * @param {string} code 字典代码
 */
function getRenshouDictData(group) {
  // return request({
  //   url: '/admin/system/dictionary/getList',
  //   method: 'get',
  //   params: { group }
  // })
  return (0, _requestMapi.default)({
    url: '/mapi/system/dictionary/list',
    method: 'get',
    params: {
      group: group
    }
  });
}

/**
 * 获取店铺类型选项（基于仁寿字典）
 */
function getStoreTypeOptions() {
  return getRenshouDictData('ykt_industry_type').then(function (res) {
    // 兼容两种返回结构：
    // 1) 直接返回数组 [{ id, name }] 或 [{ key, value }]
    // 2) 包裹在对象中 { data: [...] }
    var rawList = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
    return rawList.filter(function (item) {
      var idOrKey = item.id !== undefined && item.id !== null ? item.id : item.key;
      return String(idOrKey) !== '-1';
    }).map(function (item) {
      var idOrKey = item.id !== undefined && item.id !== null ? item.id : item.key;
      var nameOrValue = item.name !== undefined && item.name !== null ? item.name : item.value !== undefined && item.value !== null ? item.value : item.label !== undefined && item.label !== null ? item.label : '';
      return {
        value: Number(idOrKey),
        label: nameOrValue
      };
    });
  });
}